import { loadGooglePlacesApi } from "./load-api";

const CACHE: {
  geocoder?: google.maps.Geocoder;
} = {};

export async function googlePlacesGeocode(
  placeId: string,
  options: { region?: string } = {},
) {
  if (!CACHE.geocoder) {
    await loadGooglePlacesApi();
    CACHE.geocoder = new google.maps.Geocoder();
  }

  const response = await CACHE.geocoder.geocode({
    language: "en",
    placeId,
    ...options,
  });

  if (!response.results.length) {
    throw new Error("No results returned by Google Geocoder geocode");
  }

  return response.results[0];
}
